

import api from '../http'


// 查询聊天列表
export function searchChatList(data,uOpenId,cOpenId) {
  return api.request({
    url: `/frontEnd_chatList/list/${uOpenId}/${cOpenId}`,
    method: "get",
    data
  });
}

// 查询前20个
export function searchChatList20(gender) {
  return api.request({
    url: `/frontEnd_chatList/list20/${gender}`,
    method: "get",
  });
}


// 查询单个聊天
export function searchChatOne(openId) {
  return api.request({
    url: `/frontEnd_chatList/searchChatOne/${openId}`,
    method: "get"
  });
}

// 查询当前和对应用的信息
export function searchChatBeteenInfo(correspondingUserInformationOpenId,loginUserInfoOpenId) {
  return api.request({
    url: `/frontEnd_chatList/searchChatBeteenInfo/${correspondingUserInformationOpenId}/${loginUserInfoOpenId}`,
    method: "get"
  });
}

/**
 * 
 * @param {新增聊天列表} data 
 * @param {*} saltId 
 * @param {*} saltId_user 
 * @returns 
 */
export function createChatOne(data) {
  return api.request({
    url: `/frontEnd_chatList/add`,
    method: "post",
    data
  });
}

/**
 * 
 * @param {修改聊天} data 
 * @param {*} saltId 
 * @param {*} saltId_user 
 * @returns 
 */
export function updateChatOne(id,data) {
  return api.request({
    url: `/frontEnd_chatList/update/${id}`,
    method: "put",
    data
  });
}

/**
 * 
 * @param {删除指定聊天列表} data 
 * @param {*} saltId 
 * @param {*} saltId_user 
 * @returns 
 */
export function delChatOne(id) {
  return api.request({
    url: `/frontEnd_chatList/del/${id}`,
    method: "delete"
  });
}


